document.addEventListener("DOMContentLoaded", function() {
    const tabButtons = document.querySelectorAll('.size__chart_tabs .tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');
   


    function activateTab(tabId) {
         const contentSizee = document.querySelector('.content__sizee');

     document.querySelectorAll('.size__chart_tabs .tab-btn').forEach(btn => {
    btn.classList.remove('active');
  });

  document.querySelector(`.size__chart_tabs .tab-btn[data-tab="${tabId}"]`).classList.add('active');


document.querySelectorAll('.tab-content').forEach(content => {
     content.style.display = 'none';
  });
  document.querySelector(`.tab-content[id="${tabId}"]`).style.display = "";


      // 👇 Hide `.content__sizee` when "how-to-measure" tab is active
      if (contentSizee) {
        if (tabId === "how-to-measure") {
          contentSizee.style.display = "none";
        } else {
          contentSizee.style.display = "";
        }
      }
    }


    document.querySelector('.open-how-to')?.addEventListener('click', function() {
      document.getElementById("{{ id | escape }}").open = true;
      activateTab("how-to-measure");
    });

   
   

 

document.addEventListener('click', function (e) {
 const btn = e.target.closest('.size__chart_tabs .tab-btn');
  if (btn) {  
     const atr = btn.getAttribute('data-tab');
    activateTab(atr);
  }
});

  });